export const LOCALE_COOKIE = "bmbl_locale";
export const LOCALE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year

/**
 * Client-only helper used by the language switcher.
 * Import from "use client" components. No-ops on the server.
 */
export function setLocaleCookie(locale: string): void {
  if (typeof document === "undefined") return;
  const attrs = [`${LOCALE_COOKIE}=${encodeURIComponent(locale)}`, `path=/`, `max-age=${LOCALE_COOKIE_MAX_AGE_SECONDS}`, `SameSite=Lax`, location.protocol === "https:" ? "Secure" : null].filter(Boolean);
  document.cookie = attrs.join("; ");
}